module.exports = __webpack_public_path__ + "union-pay.png";